// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___2MRkl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App.scss
 ** module id = 562
 ** module chunks = 0
 **/